/**
 * Pure decision rules for the medication photo-upload coaching wizard.
 *
 * Deliberately free of any import — no react-native, no expo-secure-store — so
 * it can be unit-tested directly. The storage side lives in
 * `medication-wizard-state.ts`, which imports the cap from here.
 */

/** Wizard is shown on taps 1, 2 and 3; from the 4th tap manual entry is direct. */
export const WIZARD_MAX_SHOWS = 3;

/**
 * Should the coaching wizard open for this "Add Manually" tap?
 *
 * Drafts count as "this visit already has medications". A draft can only exist
 * if photos were already uploaded — extraction is the only thing that creates
 * one — so a pending draft is proof the nurse does not need photo coaching.
 * Note this is the OPPOSITE of the Complete Section guard, which ignores drafts
 * because completing deletes them. The two guards ask different questions.
 */
export function shouldShowWizard(input: {
    savedCount: number;
    draftCount: number;
    shownCount: number;
}): boolean {
    if (input.savedCount > 0 || input.draftCount > 0) {
        return false;
    }
    return input.shownCount < WIZARD_MAX_SHOWS;
}
